import "./Spinner.css";

interface loaderProps {
  loading?: boolean;
  size?: string;
  isWrapper?: boolean;
  borderColor?: string;
  className?: string;
}

const CustomLoader = ({
  loading,
  size = "20",
  isWrapper,
  borderColor = "#000061",
  className,
}: loaderProps) => {
  if (!loading) return null;

  return (
    <div className={className} style={{ padding: isWrapper ? "0px" : "24px" }}>
      <div
        className="custom-button-overlay"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderColor: borderColor,
        }}
      >
        {!isWrapper && <div>Please Wait...</div>}
      </div>
    </div>
  );
};

export default CustomLoader;
